const backgrounds = [
  {
    artist: 'Gregory Hardy',
    title: 'Wondering About Tomorrow',
    year: 2016,
    src: 'https://d32dm0rphc51dk.cloudfront.net/v4jnJ6rUxOIswRFSRFc5CQ/larger.jpg',
  },
  {
    artist: 'Ken Strong',
    title: 'A Parody of Ochre - Pittwater',
    year: 2014,
    src: 'https://d32dm0rphc51dk.cloudfront.net/JA2Bzjt6Qg4A2KsBpQ4pBg/larger.jpg',
  },
  {
    artist: 'Jane Booth',
    title: 'Vignette - Warmth and Wind',
    year: 2019,
    src: 'https://d32dm0rphc51dk.cloudfront.net/3B20rcJulincZU9vyZlFvA/larger.jpg',
  },
  {
    artist: 'Jane Booth',
    title: 'Vignette - Storm',
    year: 2018,
    src: 'https://d32dm0rphc51dk.cloudfront.net/HG_3yYBOlTzsurxsm2DISQ/larger.jpg',
  },
  {
    artist: 'Jane Booth',
    title: 'Vignette - Sun and Water Series A',
    year: 2018,
    src: 'https://d32dm0rphc51dk.cloudfront.net/daNz9t-QYqhvNSvZLyjqrA/larger.jpg',
  },
  {
    artist: 'Lee Bae',
    title: 'Landscape',
    year: 2002,
    src: 'https://d32dm0rphc51dk.cloudfront.net/kQDIas8iNIutUpHWRjmPYw/larger.jpg',
  },
  {
    artist: 'Jean-Michel Basquiat',
    title: 'Main Platform',
    year: 1986,
    src: 'https://d32dm0rphc51dk.cloudfront.net/1Ag7jYjuelg3xcHud-kdsQ/larger.jpg',
  },
  {
    artist: 'Joan Mitchell',
    title: 'Trees I',
    year: 1992,
    src: 'https://d32dm0rphc51dk.cloudfront.net/4WnwedDaWsf4SHJSBN0vfg/larger.jpg',
  },
  {
    artist: 'Lee Ufan',
    title: 'From Line',
    year: 1979,
    src: 'https://d32dm0rphc51dk.cloudfront.net/o3sZjQX3j6YIYYGw8JGchw/larger.jpg',
  },
  {
    artist: 'Josef Albers',
    title: 'Homage to the Square',
    year: 1969,
    src: 'https://d32dm0rphc51dk.cloudfront.net/sS5ssPUuL5ooz6Xr9EUwGw/larger.jpg',
  },
  {
    artist: 'Alex Kanevsky',
    title: 'May 12, Calm Weather',
    year: 2019,
    src: 'https://d32dm0rphc51dk.cloudfront.net/NPE-cOxhqoSRcuRPJW1o_w/larger.jpg',
  },
  {
    artist: 'Yue Minjun',
    title: 'Morning Music',
    year: 2002,
    src: 'https://d32dm0rphc51dk.cloudfront.net/JRsOSscDT33ZKFm0gmUiiw/larger.jpg',
  },
];

const getRandomBackground = () => backgrounds[Math.floor(Math.random() * backgrounds.length)];

export default {
  getRandomBackground,
};
